import { expandUtils } from './expandUtils';
import { improveReplyUtils } from './improveReplyUtils';
import { matchToStyleGuideUtils } from './matchToStyleGuideUtils';
import { quickTranslateUtils } from './quickTranslate';
import { spellingAndGrammarUtil } from './spellingAndGrammer';

export const copilotUtils = {
  matchToStyleGuide: matchToStyleGuideUtils,
  improveReply: improveReplyUtils,
  quickTranslate: quickTranslateUtils,
  spellingAndGrammar: spellingAndGrammarUtil,
  expandText: expandUtils,
};
